export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOG_OUT = 'LOG_OUT';
export const GET_UNION_LIST = 'GET_UNION_LIST';
export const GET_USER = 'GET_USER';
export const GET_SWITCH_LOGIN_AUTH = 'GET_SWITCH_LOGIN_AUTH';
export const GET_SUB_USERS = 'GET_SUB_USERS';
export const GET_LIVING_LESSONS = 'GET_LIVING_LESSONS';
